import { render, staticRenderFns } from "./Kanbandemo.vue?vue&type=template&id=83a07ec0&scoped=true"
import script from "./Kanbandemo.vue?vue&type=script&lang=js"
export * from "./Kanbandemo.vue?vue&type=script&lang=js"
import style0 from "./Kanbandemo.vue?vue&type=style&index=0&id=83a07ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a07ec0",
  null
  
)

export default component.exports